import { Button } from "src/apps/components/button/Button";
import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";

import styled from "styled-components";
import { OpenAdminAtomicBanner } from "./OpenAdminAtomicBanner";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { BasicBannerProps } from "./OpenAdminBannerByStatus";
import { colors } from "@permisso/permisso-components";

export const PendingOpenAdminBanner = ({
  title,
  description,
  buttonText,
  onButtonClick,
  isLoading = false,
  isDisabled = false,
}: BasicBannerProps) => {
  const { t } = useTranslations();

  return (
    <OpenAdminAtomicBanner
      title={t(title)}
      description={description ? t(description) : undefined}
      borderColor={colors.darkYellow}
      leftAlign="flex-start"
      leftComponent={
        <StatusIconContainer>
          <Icon
            size={ICON_SIZES.s24}
            color={colors.defaultYellow}
            path={ICON_PATHS.EXCLAMATION_CIRCLE_THIN}
          />
        </StatusIconContainer>
      }
      rightComponent={
        buttonText ? (
          <Button
            onClick={onButtonClick ?? (() => {})}
            text={t(buttonText)}
            isLoading={isLoading}
            disabled={isDisabled}
          />
        ) : undefined
      }
    />
  );
};

const StatusIconContainer = styled.div`
  display: flex;
  align-items: center;
`;
